export default __webpack_public_path__ + "static/media/English Breakfast Tea - proportioned_170.2754249e.jpg";